export const versionStringToNumber = (versionString: string) => {
  // Split the version string into major, minor, and patch components
  const [major, minor, patch] = versionString.split('.').map(Number);

  // Combine the components into a single numeric representation
  const versionNumber = major * 1000000 + minor * 10000 + patch;

  return versionNumber;
};
